import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppUserRoles } from "../../../config/constants";
import { StorageAuth } from "../../localStorage";

type SliceAuthState = {
  isLoggedIn: boolean;
  userName?: string;
  userRole?: AppUserRoles;
  companyId?: string;
  companyName?: string;
  firstName?: string;
  lastName?: string;
  profilePic?: string;
  isAutoClockInEnable?: boolean;
};

function InitSliceAuth(): SliceAuthState {
  const isLoggedIn = !!StorageAuth.AccessToken;
  const userRole = StorageAuth.Role as AppUserRoles;
  const userName = StorageAuth.UserName;
  const companyId = StorageAuth.CompanyId;
  const companyName = StorageAuth.CompanyName;
  const firstName = StorageAuth.FirstName;
  const lastName = StorageAuth.LastName;
  const profilePic = StorageAuth.ProfilePic;
  return {
    isLoggedIn,
    userRole,
    userName,
    companyId,
    companyName,
    firstName,
    lastName,
    profilePic,
  };
}

const sliceAuth = createSlice({
  name: "sliceAuth",
  initialState: InitSliceAuth(),
  reducers: {
    SetIsLoggedIn: (state, action: PayloadAction<boolean>): void => {
      state.isLoggedIn = action.payload;
    },
    SetUserRole: (state, action: PayloadAction<AppUserRoles>): void => {
      StorageAuth.Role = action.payload;
      state.userRole = action.payload;
    },
    SetUserName: (state, action: PayloadAction<string>): void => {
      StorageAuth.UserName = action.payload;
      state.userName = action.payload;
    },
    SetCompanyId: (state, action: PayloadAction<string>): void => {
      StorageAuth.CompanyId = action.payload;
      state.companyId = action.payload;
    },
    SetCompanyName: (state, action: PayloadAction<string>): void => {
      StorageAuth.CompanyName = action.payload;
      state.companyName = action.payload;
    },
    SetFirstName: (state, action: PayloadAction<string>): void => {
      StorageAuth.FirstName = action.payload;
      state.firstName = action.payload;
    },
    SetLastName: (state, action: PayloadAction<string>): void => {
      StorageAuth.LastName = action.payload;
      state.lastName = action.payload;
    },
    SetProfilePic: (state, action: PayloadAction<string>): void => {
      StorageAuth.ProfilePic = action.payload;
      state.profilePic = action.payload;
    },
  },
});

export const ReducerAuth = sliceAuth.reducer;
export const ActionAuth = sliceAuth.actions;
